import React from 'react';
import styled from 'styled-components';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { TertiaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { withLocalePrefix } from 'shared/utils/translation';
import {
  Keywords,
  CandidateFiltersGroupLayout,
  ExperienceContent,
  useExperienceState,
} from 'talent_matching/components/filters';
import AdvancedFilter from 'talent_matching/components/filters/advanced_filter';
import EducationFiltersSection from 'talent_matching/components/filters/education_filters';
import WorkPreferencesFiltersGroup from './work_preferences_filters_group';
import MyGreenhouseAppliedFilters from './my_greenhouse_applied_filters';

const t = withLocalePrefix('talent_matching.filter_row');

const NoWrap = styled(Stack)`
  white-space: nowrap;
`;

type Props = {
  onClearAll: () => void;
  children: React.ReactNode;
};

const MyGreenhouseFilterRow = ({ onClearAll, children }: Props) => {
  const experienceState = useExperienceState();
  const { setValue, watch } = useFormContext();
  const educationFilters =
    (watch('educationFilters') as AdvancedFilter[]) || [];

  const hasEducationFilters = educationFilters.some((filter) =>
    filter.applied()
  );
  const appliedCount =
    (experienceState.totalFiltersCount > 0 ? 1 : 0) +
    (hasEducationFilters ? 1 : 0);

  const handlePopoverClear = () => {
    experienceState.clear();
    setValue('educationFilters', [new AdvancedFilter()], { shouldDirty: true });
  };

  return (
    <Stack spacing={0} sx={{ marginBottom: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <NoWrap spacing={1} direction="row" alignItems="center" flexWrap="wrap">
          <CandidateFiltersGroupLayout
            appliedCount={appliedCount}
            onClear={handlePopoverClear}
            width="700px"
          >
            <ExperienceContent state={experienceState} />
            <EducationFiltersSection alwaysExpanded />
          </CandidateFiltersGroupLayout>
          <WorkPreferencesFiltersGroup />
          <Keywords />
          <TertiaryButton size="md" onClick={onClearAll}>
            {t('buttons.clear_all')}
          </TertiaryButton>
        </NoWrap>
        {children}
      </Stack>
      <MyGreenhouseAppliedFilters />
    </Stack>
  );
};

export default MyGreenhouseFilterRow;
